import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Icons from 'lucide-react';

const CompliancePage = () => {
  const navigate = useNavigate();

  const certifications = [
    {
      name: "ISO 9001:2015",
      description: "Quality Management Systems certification ensuring consistent quality in all our services and operations.",
      icon: Icons.Award
    },
    {
      name: "AYUSH Ministry Approved",
      description: "Recognition from the Government of India's Ministry of AYUSH for authentic Ayurvedic healthcare practices.",
      icon: Icons.Shield
    },
    {
      name: "WHO GMP Compliance",
      description: "Adherence to World Health Organization's Good Manufacturing Practices for healthcare products.",
      icon: Icons.CheckCircle
    },
    {
      name: "HIPAA Compliant",
      description: "Full compliance with Health Insurance Portability and Accountability Act for data privacy and security.",
      icon: Icons.Lock
    },
    {
      name: "NABH Accreditation",
      description: "National Accreditation Board for Hospitals & Healthcare Providers certification for quality healthcare.",
      icon: Icons.Building2
    },
    {
      name: "FDA Compliance",
      description: "Adherence to Food and Drug Administration standards for healthcare products and equipment.",
      icon: Icons.FileCheck
    }
  ];

  return (
    <div style={{ background: 'var(--bg-page)', paddingTop: '80px', minHeight: '100vh' }}>
      <div className="container" style={{ padding: '3rem 1.2rem', maxWidth: '1000px', margin: '0 auto' }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            color: '#22c55e',
            cursor: 'pointer',
            marginBottom: '2rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          ← Back
        </button>

        <h1 className="heading-1" style={{ marginBottom: '1rem' }}>Compliance & Certifications</h1>
        <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '3rem' }}>
          At Ayurmed Global, we maintain the highest standards of compliance with international healthcare regulations 
          and quality certifications to ensure safe, effective, and trustworthy services.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '3rem' }}>
          {certifications.map((cert, index) => {
            const IconComponent = cert.icon;
            return (
              <div
                key={index}
                style={{
                  background: 'rgba(34, 197, 94, 0.1)',
                  borderRadius: '1rem',
                  padding: '2rem',
                  border: '1px solid rgba(34, 197, 94, 0.3)',
                }}
              >
                <IconComponent size={40} color="#22c55e" style={{ marginBottom: '1rem' }} />
                <h3 className="heading-3" style={{ color: '#22c55e', marginBottom: '0.75rem' }}>{cert.name}</h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>{cert.description}</p>
              </div>
            );
          })}
        </div>

        <div style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
          <h2 className="heading-2" style={{ marginBottom: '1.5rem', marginTop: '2rem' }}>Our Commitment to Compliance</h2>
          
          <h3 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>Data Protection</h3>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            We implement robust data protection measures in accordance with international standards including GDPR and 
            India's Personal Data Protection guidelines. All patient and business data is encrypted and stored securely.
          </p>

          <h3 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>Quality Assurance</h3>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            Our quality management system ensures consistent delivery of services that meet or exceed regulatory requirements. 
            Regular audits and reviews are conducted to maintain our certification standards.
          </p>

          <h3 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>Ethical Practices</h3>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            We adhere to strict ethical guidelines in all our business practices, ensuring transparency, fairness, 
            and integrity in our dealings with clients, partners, and stakeholders.
          </p>

          <h3 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>Contact for Compliance Queries</h3>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            For any compliance-related questions or concerns, please contact our compliance team at:<br />
            Email: info@ayurmedglobal.com<br />
            Phone: +91-9958096324
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompliancePage;
